import React, {forwardRef} from 'react';

import {useAppDispatch, useAppSelector} from '../../../../helpers/appReduxHelpers';
import {AnalyticsScalarMetricsEnum} from '../../../../models/api/analyticsMetricsModel';
import {setMetricDetailsAction} from '../../../../store/panels/analytics/details/analyticsPanelDetailsActions';
import {makeGetAnalyticsMetric} from '../../../../store/panels/analytics/report/analyticsPanelReportSelectors';
import {ReportElementIdsEnum} from '../../../helpers/reportHelpers/reportTypes';
import {KeyMetric} from './keyMetric';

/*
 * Props.
 */

export interface ReportKeyMetricProps {
  metricId: AnalyticsScalarMetricsEnum;
  reportSectionId: ReportElementIdsEnum; // Used for tracking purpose.
  isLoading: boolean;
  onClickCustom?: (arg: AnalyticsScalarMetricsEnum) => void;
}

/*
 * Component.
 */

export const ReportKeyMetric = forwardRef<HTMLDivElement, ReportKeyMetricProps>(
  ({metricId, reportSectionId, isLoading, onClickCustom}, ref) => {
    const dispatch = useAppDispatch();
    const [metricData, metricError] = useAppSelector(makeGetAnalyticsMetric(metricId));

    return (
      <KeyMetric
        ref={ref}
        isLoading={isLoading}
        reportSectionId={reportSectionId}
        metricData={metricData}
        metricError={metricError}
        onClick={(id) => {
          if (onClickCustom) {
            onClickCustom(id);
            return;
          }
          dispatch(setMetricDetailsAction(id));
        }}
      />
    );
  },
);
